import React from 'react'

const Footer = () => {
  return (
    <div className='Footer'>
        <div className='FooterItem'>
      SINO LOGISTICS CORPORATION PUBLIC COMPANY LIMITED | S-CRM V2.4 (Last Update 19 June 2026)</div>
      </div>
  )
}

export default Footer